import { memo, useRef } from 'react';
import FloatAnimation, { FloatAnimationVariant } from './FloatAnimation';
import GlowAnimation from './GlowAnimation';

interface IconProps {
  className?: string;
}

function ClearDayIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-clear-day"
    >
      <g filter="url(#filter0_d_clear_day)">
        <circle cx="60" cy="60" r="27" fill="#FFA51F">
          <FloatAnimation variant={FloatAnimationVariant.SunDrift} />
        </circle>
      </g>
      <defs>
        <filter
          id="filter0_d_clear_day"
          x="17"
          y="17"
          width="86"
          height="86"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8">
            <GlowAnimation />
          </feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(ClearDayIcon);
